const FALLBACK_ADVERTISER_ROLE_KEYS = [
  "Owner",
  "Real Estate Broker",
  "Direct with the Owner",
  "Among Real Estate Brokers",
  "Advertiser",
  "Owner's Agent",
  "Real Estate Developer",
];

/// Build consistent advertiser-role options for request/listing forms.
export const buildAdvertiserRoleOptions = (types) => {
  if (Array.isArray(types) && types.length > 0) {
    return types.map((item) => ({
      ...item,
      key: item?.key || item?.value,
      value: item?.key || item?.value,
      label: item?.label || item?.name || item?.key || item?.value,
    }));
  }

  return FALLBACK_ADVERTISER_ROLE_KEYS.map((key) => ({
    key,
    value: key,
    label: key,
  }));
};

/// Accept DB key, translated label, or legacy text and normalize to option value.
export const normalizeAdvertiserRoleValue = (rawValue, options) => {
  const value = String(rawValue || "").trim();
  if (!value) {
    return "";
  }

  const lowered = value.toLowerCase();
  const match = (options || []).find((option) => {
    const candidates = [option?.value, option?.key, option?.label]
      .filter(Boolean)
      .map((item) => String(item).trim().toLowerCase());
    return candidates.includes(lowered);
  });

  return match?.value || value;
};

/// Resolve the best display label for request cards from a stored role value.
export const resolveAdvertiserRoleLabel = (rawValue, options) => {
  const normalized = normalizeAdvertiserRoleValue(rawValue, options);
  if (!normalized) {
    return "";
  }

  const match = (options || []).find((option) => option?.value === normalized);
  return match?.label || normalized;
};
